/**
 * Build a Google Maps URL pointing at a place. Preference order:
 *   1. `place_id:<gpid>` form — canonical Google place page when we have an id
 *   2. `?api=1&query=<lat>,<lng>` form — coords-only fallback
 *   3. `?api=1&query=<name>` — last-ditch text search by name
 *   4. plain maps.google.com — should never happen with a populated place
 *
 * Used by `LocationChips` (legacy outbound chip link) and by
 * `LocationViewerModal` (explicit "Open in Google Maps" button).
 */
export function googleMapsUrl(opts: {
  googlePlaceId?: string | null
  lat?: number | null
  lng?: number | null
  name?: string | null
}): string {
  if (opts.googlePlaceId) {
    return `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(opts.googlePlaceId)}`
  }
  if (opts.lat != null && opts.lng != null) {
    return `https://www.google.com/maps/search/?api=1&query=${opts.lat},${opts.lng}`
  }
  if (opts.name) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(opts.name)}`
  }
  return 'https://www.google.com/maps'
}
